<template>
  <PromotionElement
    v-if="!hidePromotionElement"
    :headline="currentPromotionElement.headline"
    :description="currentPromotionElement.description"
    :href="currentPromotionElement.href"
    :crm-property="currentPromotionElement.crmProperty"
  />
</template>

<script>
import PromotionElement from '@/components/PromotionElement.vue'

export default {
  name: 'PromotionElementSection',

  components: {
    PromotionElement,
  },

  computed: {
    hidePromotionElement () {
      return this.$auth.user.crm && this.$auth.user.crm[this.currentPromotionElement.crmProperty] === true
    },

    currentPromotionElement () {
      const promotionElements = [
        {
          headline: this.$t('layout.header.promotion_element.compare_indexes.title'),
          description: this.$t('layout.header.promotion_element.compare_indexes.description'),
          href: this.$utm(this.$t('data.pf_links.manual_compare_indexes'), 'header-promotion-compare-indexes-manual-link'),
          crmProperty: this.$config.constants.CRM_FEATURE_FLAGS.HIDE_COMPARE_INDEXES_PROMOTION_ELEMENT,
        },
      ]

      return promotionElements[0]
    },
  },
}
</script>
